import * as React from 'react'

import { ErrorBoundary } from '@/modules/shared/components/ErrorBoundary'
import { TimesheetBasicPageContent } from './TimesheetBasicPageContent'
import { ErrorFallback } from '@/modules/shared/components/ErrorFallback'
import { RouteComponentProps } from '@/app/navigation/withRouter'

export const TimesheetBasicPage = (props: RouteComponentProps<{ companyId: string }>) => {
  return  (
    <ErrorBoundary fallback={(e) => <ErrorFallback error={e.error} onRetry={e.reset} />}>
      <TimesheetBasicPageContent {...props} />
    </ErrorBoundary>
  )
}
